import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = ({ theme }) => {
  // --- ADDED MOBILE STATE ---
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // --- ADDED EMAIL HANDLER ---
  const handleEmailClick = () => {
    window.location.href = 'mailto:sales@siteact.app';
  };

  return (
    <section style={{ 
      padding: isMobile ? '100px 20px 60px' : '120px 20px 80px', // Responsive padding
      background: `linear-gradient(180deg, ${theme.bgLight} 0%, #fff 100%)`,
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        
        {/* Trust Badge */}
        <div style={{ 
          display: 'inline-flex', alignItems: 'center', gap: '8px',
          padding: '8px 16px', borderRadius: '30px', background: '#e0f2fe', 
          color: theme.primary, fontWeight: '600', fontSize: '0.9rem', marginBottom: '30px'
        }}>
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: theme.primary }}></span>
          New: Unlimited Contractor Registry
        </div>

        <h1 style={{ 
          fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontWeight: '800', 
          letterSpacing: '-1px', lineHeight: '1.1', marginBottom: '25px', color: theme.secondary 
        }}>
          The Operating System for <br />
          <span style={{ color: theme.primary }}>
            Site Safety & Compliance
          </span>
        </h1>

        <p style={{ 
          fontSize: isMobile ? '1.1rem' : '1.25rem', // Scales down slightly on phones
          color: '#64748b', maxWidth: '750px', margin: '0 auto 40px', lineHeight: '1.6' 
        }}>
          Whether you run a <strong>construction project</strong> or a <strong>manufacturing plant</strong>: control every worker, permit, and risk on your site.
          <br />
          <strong>No app to download.</strong> Instant compliance for contractors.
        </p>

        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '60px' }}>
          
          <button 
            onClick={handleEmailClick} // <-- TRIGGER EMAIL
            style={{ 
              padding: '16px 32px', borderRadius: '8px', border: 'none', 
              background: theme.primary, color: 'white', fontSize: '1.1rem', fontWeight: 'bold', 
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
              width: isMobile ? '100%' : 'auto' // Full width on mobile
            }}
          >
            Start Free Trial <ArrowRight size={20} />
          </button>
          
          <button 
            onClick={handleEmailClick} // <-- TRIGGER EMAIL
            style={{ 
              padding: '16px 32px', borderRadius: '8px', border: `1px solid #cbd5e1`, 
              background: 'white', color: theme.secondary, fontSize: '1.1rem', fontWeight: '600', cursor: 'pointer',
              width: isMobile ? '100%' : 'auto' // Full width on mobile
            }}
          >
            Book a Demo
          </button>
        
        </div>

        {/* Social Proof Bar */}
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '40px' }}>
          <p style={{ fontSize: '0.9rem', color: '#94a3b8', marginBottom: '20px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Trusted by construction firms & industrial facilities
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', opacity: 0.6, flexWrap: 'wrap', filter: 'grayscale(100%)' }}>
         
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;